const _sitemap = [
  {
    title: "SALAXY.PRO_Sitemap.customers.main",
    url: "#/pro/index",
    id: "pro-customers",
    isFullWidth: true,
    isPro: true,
    children: [
      {
        title: "SALAXY.PRO_Sitemap.customers.customerQuery.main",
        url: "#/pro/customer-query",
        isFullWidth: true
      },
      {
        title: "SALAXY.PRO_Sitemap.customers.settings.main",
        url: "#/pro/settings",
        isFullWidth: true,
        roles: "test"
      },
      {
        title: "SALAXY.PRO_Sitemap.import.companies.main",
        url: "#/pro/import-companies",
        isFullWidth: true,
        roles: "test"
      }
    ]
  },
  {
    title: "SALAXY.PRO_Sitemap.calcPaid.main",
    url: "#/pro/calc-paid",
    id: "pro-paid",
    isFullWidth: true,
    isPro: true,
    children: [
      {
        title: "SALAXY.PRO_Sitemap.calcPaid.paid.main",
        url: "#/pro/calc-paid",
        isFullWidth: true
      },
      {
        title: "SALAXY.PRO_Sitemap.calcPaid.payrollPaid.main",
        url: "#/pro/payroll-paid",
        isFullWidth: true
      },
      {
        title: "SALAXY.PRO_Sitemap.calcPaid.invoices.main",
        url: "#/pro/invoices",
        isFullWidth: true
      }
    ]
  },
  {
    title: "SALAXY.PRO_Sitemap.calcDraft.main",
    url: "#/pro/calc-draft",
    id: "pro-salaries",
    isFullWidth: true,
    isPro: true,
    roles: "!proPartnerService",
    children: [
      {
        title: "SALAXY.PRO_Sitemap.calcDraft.draft.main",
        url: "#/pro/calc-draft",
        isFullWidth: true
      },
      {
        title: "SALAXY.PRO_Sitemap.calcDraft.calcAssigned.main",
        url: "#/pro/calc-assigned",
        isFullWidth: true
      },
      {
        title: "SALAXY.PRO_Sitemap.calcDraft.calcArchive.main",
        url: "#/pro/calc-archive",
        isFullWidth: true
      },
      {
        title: "SALAXY.PRO_Sitemap.calcDraft.workers.main",
        url: "#/pro/workers",
        isFullWidth: true
      },
      {
        title: "SALAXY.PRO_Sitemap.calcDraft.payrollDraft.main",
        url: "#/pro/payroll-draft",
        isFullWidth: true
      },
      {
        title: "SALAXY.PRO_Sitemap.calcDraft.invoicesHandle.main",
        url: "#/pro/invoices-handle",
        isFullWidth: true,
        roles: "test,palkkausManual"
      },
      {
        title: "SALAXY.PRO_Sitemap.calcDraft.taxCards.main",
        url: "#/pro/taxcards",
        roles: "test",
        isFullWidth: true
      },
      {
        title: "SALAXY.PRO_Sitemap.import.workers.main",
        url: "#/pro/import-workers",
        isFullWidth: true,
        roles: "test"
      },
      {
        title: "SALAXY.PRO_Sitemap.import.calcs.main",
        url: "#/pro/import-calcs",
        isFullWidth: true,
        roles: "test"
      }
    ]
  },
  {
    title: "SALAXY.PRO_Sitemap.serviceCalc.main",
    url: "#/pro/service-calc",
    id: "pro-service",
    isFullWidth: true,
    isPro: true,
    roles: "proPartnerService",
    children: [
      {
        title: "SALAXY.PRO_Sitemap.serviceCalc.newCalc.main",
        url: "#/pro/service-calc",
        isFullWidth: true
      },
      {
        title: "SALAXY.PRO_Sitemap.serviceCalc.serviceCalcAssigned.main",
        url: "#/pro/service-calc-assigned",
        isFullWidth: true
      },
      {
        title: "SALAXY.PRO_Sitemap.serviceCalc.serviceCalcArchive.main",
        url: "#/pro/service-calc-archive",
        isFullWidth: true
      },
      {
        title: "SALAXY.PRO_Sitemap.serviceCalc.serviceWorkers.main",
        url: "#/pro/service-workers",
        isFullWidth: true
      },
      {
        title: "SALAXY.PRO_Sitemap.serviceCalc.invoicesHandle.main",
        url: "#/pro/invoices-handle",
        isFullWidth: true,
        roles: "test,palkkausManual"
      }
    ]
  },
  {
    title: "SALAXY.PRO_Sitemap.selfServicePaid.main",
    url: "#/pro/self-service-paid",
    id: "pro-self-service",
    isFullWidth: true,
    isPro: true,
    roles: "proPartnerService",
    children: [
      {
        title: "SALAXY.PRO_Sitemap.selfServicePaid.selfServicePaid.main",
        url: "#/pro/self-service-paid",
        isFullWidth: true
      },
      {
        title: "SALAXY.PRO_Sitemap.selfServicePaid.selfServiceDraft.main",
        url: "#/pro/self-service-draft",
        isFullWidth: true
      },
      {
        title: "SALAXY.PRO_Sitemap.selfServicePaid.serviceWorkers.main",
        url: "#/pro/self-service-workers",
        isFullWidth: true
      },
      {
        title: "SALAXY.PRO_Sitemap.selfServicePaid.selfServicePayroll.main",
        url: "#/pro/self-service-payroll",
        isFullWidth: true
      }
    ]
  },
  {
    title: "SALAXY.PRO_Sitemap.messages.main",
    url: "#/pro/messages",
    id: "pro-messages",
    isFullWidth: true,
    isPro: true,
    children: [
      {
        title: "SALAXY.PRO_Sitemap.messages.messagesNew.main",
        url: "#/pro/messages",
        isFullWidth: true
      },
      {
        title: "SALAXY.PRO_Sitemap.messages.messagesAssigned.main",
        url: "#/pro/messages-assigned",
        isFullWidth: true
      },
      {
        title: "SALAXY.PRO_Sitemap.messages.messagesArchive.main",
        url: "#/pro/messages-archive",
        isFullWidth: true
      }
    ]
  },
  {
    title: "SALAXY.PRO_Sitemap.reports.main",
    url: "#/pro/reports-accounting",
    id: "pro-reports",
    isFullWidth: true,
    isPro: true,
    children: [
      {
        title: "SALAXY.PRO_Sitemap.reports.reportsAccounting.main",
        url: "#/pro/reports-accounting",
        isFullWidth: true
      },
      {
        title: "SALAXY.PRO_Sitemap.reports.reportsSalarySlip.main",
        url: "#/pro/reports-salary-slips",
        roles: "test"
      },
      {
        title: "SALAXY.PRO_Sitemap.reports.reportsEprNew.main",
        url: "#/pro/reports-epr",
        isFullWidth: true
      },
      {
        title: "SALAXY.PRO_Sitemap.reports.odataTester.main",
        url: "#/pro/odata-tester",
        roles: "test",
        isFullWidth: true
      },
      {
        title: "SALAXY.PRO_Sitemap.reports.reportsPsrNew.main",
        url: "#/pro/reports-psr",
        isFullWidth: true
      },
      {
        title: "SALAXY.PRO_Sitemap.reports.hourlyReports.main",
        url: "#/pro/hourly-reports",
        roles: "test"
      },
      {
        title: "SALAXY.PRO_Sitemap.reports.reportsHouseholdYears.main",
        url: "#/pro/reports-household-years",
        roles: "householdService",
        isFullWidth: true
      }
    ]
  },
  {
    title: "SALAXY.PRO_Sitemap.settingsService.main",
    url: "#/pro/settings-service",
    id: "pro-settings",
    isPro: true,
    visibility: "hidden",
    children: [
      {
        title: "SALAXY.PRO_Sitemap.settingsService.settingsService.main",
        url: "#/pro/settings-service"
      },
      {
        title: "SALAXY.PRO_Sitemap.settingsService.settingsAuthorizations.main",
        url: "#/pro/settings-authorizations"
      },
      {
        title: "SALAXY.PRO_Sitemap.settingsService.paymentChannel.main",
        url: "#/pro/payment-channel"
      }
    ]
  },
  {
    title: "SALAXY.PRO_Sitemap.serviceModels.main",
    url: "#/pro/service-models",
    id: "serviceModel",
    isPro: true,
    roles: "test",
    children: [
      {
        url: "#/pro/service-models",
        title: "SALAXY.PRO_Sitemap.serviceModels.index.main",
        id: "serviceModels",
        roles: "test",
        isPro: true,
        children: [{
          title: "SALAXY.PRO_Sitemap.serviceModels.index.serviceModelsDetails.main",
          url: "#/pro/service-models/details/*",
          isFullWidth: true,
          id: "details",
          roles: "test",
          visibility: "hidden"
        }]
      },
      {
        id: "usecases",
        url: "#/pro/usecases/index",
        title: "SALAXY.PRO_Sitemap.serviceModels.usecases.main",
        roles: "test",
        children: [
          {
            title: "SALAXY.PRO_Sitemap.serviceModels.usecases.usecaseDetails.main",
            id: "details",
            roles: "test",
            visibility: "hidden",
            url: "#/pro/usecases/details/*",
            isFullWidth: true
          }
        ]
      },
      {
        id: "accounting-targets",
        url: "#/pro/accounting-targets/index",
        title: "SALAXY.PRO_Sitemap.serviceModels.accountingTargets.main",
        roles: "test",
        isFullWidth: true,
        children: [
          {
            title: "SALAXY.PRO_Sitemap.serviceModels.accountingTargets.accountingTargetDetails.main",
            id: "details",
            roles: "test",
            isFullWidth: true,
            visibility: "hidden",
            url: "#/pro/accounting-targets/details/*"
          }
        ]
      },
      {
        title: "SALAXY.PRO_Sitemap.serviceModels.calcAutomation.main",
        url: "#/pro/calc-automation",
        isFullWidth: true,
        roles: "test"
      }
    ]
  },
  {
    title: "SALAXY.PRO_Sitemap.serviceModels.accountingTargets.main",
    url: "#/pro/accounting-targets/index",
    id: "partner-settings",
    isPro: true,
    roles: "accountingTargets"
  },
  {
    title: "SALAXY.PRO_Sitemap.serviceModels.customer.main",
    url: "#/home",
    id: "customer",
    children: []
  }
];
export const sitemap = _sitemap;
